module.exports = __webpack_public_path__ + "static/img/quxiaoquantijingyin.c3d580c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/quxiaoquantijingyin.png
// module id = Cly6
// module chunks = 24